import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Text, TextTypography } from '../Text/Text';
import { Icon } from '../Icon/Icon';
import { ReactComponent as PromoIcon } from 'assets/icons/additional/promo-icon.svg';
import i18n from '../../../i18n';

export interface PromoButtonProps {
    onClick: () => void;
}

const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: theme.palette.fixedPromo.accent,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(2),
    },
    icon: {
        height: 48,
        width: 48,
        borderRadius: 12,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

export const PromoButton = (props: PromoButtonProps) => {
    const { onClick } = props;
    const classes = useStyles();
    const { t } = i18n.useTranslation();
    return (
        <div className={classes.container} onClick={onClick}>
            <div>
                <Text typography={TextTypography.LEAD_ACCENT}>{t('common:userMenu:promoButton')}</Text>
                <Text typography={TextTypography.BODY}>{t('common:userMenu:promoText')}</Text>
                <Text typography={TextTypography.BODY}>{t('common:userMenu:promoTextPrice')}</Text>
                <Text typography={TextTypography.BODY}>{t('common:userMenu:promoTextCancel')}</Text>
            </div>
            <div className={classes.icon}>
                <Icon color={'white'} component={PromoIcon} svgSize={48} size={48} />
            </div>
        </div>
    );
};
